import styled from "styled-components"

import media from "../../global/media"

interface StyledProps {
  backgroundColor: string
  backgroundPosition: string
  backgroundSize: string
  tabletBackgroundPosition: string
  tabletBackgroundSize: string
  minHeight: number
  tabletMinHeight: number
  src: string
  radius: string
}

const StyledBanner = styled.div<StyledProps>`
  ${({backgroundColor}) => backgroundColor && `background-color: ${backgroundColor};`}
  ${({backgroundPosition}) => backgroundPosition && `background-position: ${backgroundPosition};`}
  ${({backgroundSize}) => backgroundSize && `background-size: ${backgroundSize};`}
  ${({minHeight}) => minHeight && `min-height: ${minHeight}px;`}
  ${({radius}) => radius && `border-radius: ${radius};`}
  background-image: url("${({src}) => src}");
  background-repeat: no-repeat;
  position: relative;

  ${media.tablet`
    ${({tabletBackgroundPosition}) => tabletBackgroundPosition && `background-position: ${tabletBackgroundPosition};`}
    ${({tabletBackgroundSize}) => tabletBackgroundSize && `background-size: ${tabletBackgroundSize};`}
    ${({tabletMinHeight}) => tabletMinHeight && `min-height: ${tabletMinHeight}px;`}
  `}
  a:hover, a:focus {
    text-decoration: none;
  }
`

export default StyledBanner
